import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { fetchStaffAttendanceSummary, selectStaffAttendanceSummary } from "../features/attendance/staff-attendance.slice";

const useStaffAttendanceSummary = () => {
    const dispatch = useAppDispatch();
    const summary = useAppSelector(selectStaffAttendanceSummary);

    const getAttendanceSummary = async () => {
        await dispatch(fetchStaffAttendanceSummary());
    }

    useEffect(() => {
        getAttendanceSummary();
    }, []);

    return summary;
}
 
export default useStaffAttendanceSummary;